import dayjs from "dayjs";
import { upperFirst } from "lodash-es";
import * as xlsx from "xlsx";
//#region src/modules/Reports/shared/reports-summary-download.ts
function reportsSummaryDownload(reports, deps, config) {
	const arrayOfArrays = [[
		"ID",
		"Date",
		"Title",
		"Sub Title",
		"Authors Users",
		"State"
	]];
	reports.forEach((report) => {
		arrayOfArrays.push([
			report.idLabel || "",
			dayjs(report.date).format("YYYY/MM/DD"),
			report.title,
			report.subTitle || "",
			report.authors?.reduce((acc, authorUser) => {
				let userString = "";
				if (authorUser.displayName) userString += authorUser.displayName;
				if (authorUser.idNumber) userString += ` (${authorUser.idNumber})`;
				if (userString) acc.push(userString);
				return acc;
			}, []).join(", ") || "",
			upperFirst(report.state)
		]);
	});
	const ws = xlsx.utils.aoa_to_sheet(arrayOfArrays);
	const wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, "Summary");
	if (config.format === "csv") xlsx.writeFile(wb, `${config.fileName}.csv`, { bookType: "csv" });
	else xlsx.writeFile(wb, `${config.fileName}.xlsx`, { bookType: "xlsx" });
}
//#endregion
export { reportsSummaryDownload };

//# sourceMappingURL=reports-summary-download.js.map